import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";

interface CustomProps {
  isVisible: boolean;
  handleDialogClose: Function;
}

const ContactDelateModal = (props: CustomProps) => {
  const theme = useTheme();
  const getDialogHeader = () => {
    return (
      <>
        <Box display={"flex"} justifyContent={"center"}>
          <Typography variant="h4" color={theme.palette.primary.main}>
            Please Confirm
          </Typography>
        </Box>
      </>
    );
  };

  const getBody = () => {
    return (
      <>
        <Box
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
        >
          <Typography variant="h4" textAlign={"center"}>
            {`${"Remove Contact(media@botton.com)"}`}
          </Typography>
          <Typography variant="subtitle2" textAlign={"center"} pt={1}>
            {`${"Do you really want to remove subscriber mansiy.softsages@gmail.com?"}`}
          </Typography>

          <Box bgcolor={"#FFF9F3"} mt={3} p={2} justifyContent={"center"}>
            <Typography
              variant="subtitle2"
              color={"#FF9436"}
              textAlign={"center"}
            >
              Removes the subscriber from your account, but all their
              information is still kept in case they re-subscribe to your list.
            </Typography>
          </Box>
        </Box>
      </>
    );
  };
  const getFooter = () => {
    return (
      <Stack direction="row" spacing={2} mb={1}>
        <Button
          id="contacts_add__cancel_btn"
          variant="outlined"
          sx={{
            width: "7.125rem",
            height: "2.5rem",
          }}
        >
          Delete
        </Button>
        <Button
          id="contacts_add_save_btn"
          variant="contained"
          onClick={() => props.handleDialogClose()}
          sx={{
            width: "7.125rem",
            height: "2.5rem",
          }}
        >
          Cancel
        </Button>
      </Stack>
    );
  };

  return (
    <CustomDialog
      handleDialogClose={props.handleDialogClose}
      isDialogOpen={props.isVisible}
      title={getDialogHeader()}
      body={getBody()}
      footer={getFooter()}
      closeButtonVisibility={false}
      closable
    />
  );
};

export default ContactDelateModal;
